import React from 'react';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

import { useAppSelector } from 'store';

import { mapSortValueToSortFields, useCourses } from 'modules/courses';
import { isEmptyArr } from 'modules/global';

import { EmptyData, Visible } from 'components';

import CourseCard from '../course-card';
import CourseSkeleton from '../course-skeleton';
import LoadMoreButton from '../load-more-button';

const CoursesList = () => {
  const t = useTranslations();
  const { query } = useRouter();
  const { type, method, sort, categoryIds } = useAppSelector(({ courses }) => ({
    type: courses?.type,
    method: courses?.method,
    sort: courses?.sort,
    categoryIds: courses?.categoryIds
  }));

  const sortFields = mapSortValueToSortFields(sort);

  const { courses, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading } = useCourses({
    type: method === 'both' ? undefined : method,
    search: query?.search as string,
    enabled: type === 'courses',
    ...sortFields,
    categoryIds
  });

  return (
    <Visible
      if={isLoading}
      else={
        <Visible
          if={isEmptyArr(courses)}
          else={
            <>
              <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                {courses?.map(course => <CourseCard key={course?.id} course={course} />)}

                {isFetchingNextPage &&
                  // eslint-disable-next-line react/no-array-index-key
                  Array.from({ length: 4 }).map((_, index) => <CourseSkeleton key={index} />)}
              </div>

              {hasNextPage && <LoadMoreButton fetchNextPage={fetchNextPage} isFetchingNextPage={isFetchingNextPage} />}
            </>
          }
        >
          <EmptyData title={t('malumot_topilmadi')} />
        </Visible>
      }
    >
      <div className="grid grid-cols-4 gap-3">
        {Array.from({ length: 6 }).map((_, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <CourseSkeleton key={index} />
        ))}
      </div>
    </Visible>
  );
};

export default CoursesList;
